import React from 'react';
import Button from '../../../../../component/ui/Button';

export default function AccountDetailHeader({
	setIsOpenAccount,
	status,
	accountName,
	accountType,
	setType,
	setAccountId,
	setIsOpenActivateAccountModal,
	setIsOpenDeactivateAccountModal,
}) {
	return (
		<div
			className="d-flex justify-content-between align-items-center  sticky-top z-3 p-4"
			style={{ backgroundColor: '#EDEDF7', borderBottom: '1px sold #0850ea' }}
		>
			<div>
				<div className="d-flex align-items-center gap-2">
					<span className="fs-4 fw-light">Settings</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span className="fs-4 fw-light">Accounting</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span
						className="fs-4 fw-light text-primary cursor-pointer"
						onClick={() => setType('account-list')}
					>
						Accounts
					</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span className="fs-4 fw-light">{accountName || ''}</span>
				</div>
				<div className="fs-3 fw-bold text-black">{accountName}</div>
				<div className="fs-3 fw-light text-black">{accountType}</div>
				<div
					className="fs-5 fw-light"
					style={{ color: '#718096' }}
				>
					See account details and all the transactions under the account.
				</div>
			</div>
			<div className="d-flex gap-3 align-items-center">
				<Button
					type="button"
					button={'Edit'}
					disabled={false}
					className="btn-primary mt-0 px-3"
					onClick={() => setIsOpenAccount(true)}
				/>
				<Button
					type="button"
					button={'Export'}
					disabled={false}
					className="btn-gray mt-0 px-3"
					onClick={() => {}}
				/>
				<Button
					type="button"
					button={status === 1 ? 'Deactivate' : 'Activate'}
					disabled={false}
					className={`${status === 1 ? 'btn-danger' : 'btn-success'} mt-0 px-3`}
					onClick={() => {
						if (status === 0) {
							setIsOpenActivateAccountModal(true);
						} else if (status === 1) {
							setIsOpenDeactivateAccountModal(true);
						}
					}}
				/>
				<Button
					type="button"
					disabled={false}
					className="btn-danger mt-0"
					close
					onClick={() => {
						setType('account-list');
						setAccountId(null);
					}}
				/>
			</div>
		</div>
	);
}
